import { ClipboardCheck, PhoneCall, Sparkles } from "lucide-react";

// Colour carries urgency only; the icon carries the item type.
export const TYPE_META = {
  quotation_approval: { icon: ClipboardCheck, label: "Approvals", cta: "Review Quote", dot: "bg-danger", tile: "bg-accent/10 text-accent" },
  ai_preview_ready: { icon: Sparkles, label: "AI Previews", cta: "View Preview", dot: "bg-warning", tile: "bg-warning/15 text-[hsl(41_60%_35%)]" },
  followup_due: { icon: PhoneCall, label: "Follow-ups", cta: "Contact", dot: "bg-warning", tile: "bg-success/10 text-success" },
};

export const typeMeta = (type) => TYPE_META[type] || TYPE_META.ai_preview_ready;
